<template>
  <v-app>
    <v-main>
      <v-container class="mt-0">
        <v-row class="d-flex justify-center">
          <v-col lg="4" md="6" sm="8" cols="10">
            <v-img
              alt="DSDA Logo"
              class="shrink mx-auto"
              contain
              src="../assets/icon.png"
              transition="scale-transition"
              height="100px"
            />
            <v-card color="primary" dark class="mt-2">
              <v-card-text>
                <v-row class="text-center">
                  <v-col>
                    <h2 style="color:white">You Are Already Registered!</h2>
                  </v-col>
                </v-row>
                <v-divider class="mx-2 mt-2"></v-divider>
                <v-row>
                  <v-col cols="12" class="mt-2 text-center">
                   <p>Wait for your administrator to confirm your account!</p>
                   <v-btn
                      color="warning"
                      class="float-end"
                      @click="LogIn"
                    >
                      Log In
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

         <v-row class="d-flex justify-center">
          <v-col>
            <v-card flat class="my-4">
              <v-row no-gutters class="text-center">
                <v-col>
                  <v-img
                    alt="Dinas Logo"
                    class="shrink float-left"
                    contain
                    src="@/assets/provinsi.png"
                    transition="scale-transition"
                    width="70"
                  />
                  <div class="text-caption">DINAS SUMBER DAYA AIR PROVINSI JAWA BARAT</div>  
                  <div class="text-caption">Jl.Braga No.137, Babakan Ciamis, Kec. Sumur Bandung,</div>
                  <div class="text-caption">Kota Bandung, Jawa Barat 40111 (022) 4236113</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: 'DataPage',

    data: () => ({
      show1: false,
    }),
    mounted () {
    },
    methods: {
      LogIn() {
        this.$router.push('login')
      }
    },
  }
</script>
